import { useState } from 'react';
import { trpc } from '@/lib/trpc';
import { ui, errText } from './envUi';

/** Name / Number / Password sign-in card shared by every admin entry point. */
export default function AdminLoginForm({ onSuccess, title = 'Admin sign in' }: { onSuccess: () => void; title?: string }) {
  const [form, setForm]   = useState({ name: '', phone: '', password: '' });
  const [error, setError] = useState('');
  const login = trpc.questionnaire.adminLogin.useMutation();

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    try {
      const res = await login.mutateAsync(form);
      if (res.admin) onSuccess(); else setError('Those details are not recognised.');
    } catch (err) {
      setError(errText(err));
    }
  };

  return (
    <form onSubmit={submit} className={`${ui.card} flex w-full max-w-xs flex-col gap-4 p-6`}>
      <h2 className="text-center text-lg font-bold">{title}</h2>
      {([
        ['name',     'Name',     'text'],
        ['phone',    'Number',   'tel'],
        ['password', 'Password', 'password'],
      ] as const).map(([key, label, type]) => (
        <div key={key}>
          <label className={ui.label} htmlFor={`al-${key}`}>{label}</label>
          <input id={`al-${key}`} className={ui.input} type={type}
                 autoComplete={key === 'password' ? 'current-password' : 'off'}
                 {...(key === 'phone' ? { inputMode: 'numeric' as const } : {})}
                 value={form[key]}
                 onChange={e => {
                   setError('');
                   const v = key === 'phone' ? e.target.value.replace(/\D/g, '').slice(0, 8) : e.target.value;
                   setForm(f => ({ ...f, [key]: v }));
                 }} />
        </div>
      ))}
      {error && <p className="text-sm text-red-600 dark:text-red-400">{error}</p>}
      <button type="submit" disabled={login.isPending} className={`${ui.btn} w-full`}>
        {login.isPending ? 'Please wait…' : 'Sign in'}
      </button>
    </form>
  );
}
